<template>
    <div class="event-promotion">
        <h3 class="event-promotion__title">{{ langJson('Ticketing URL') }}</h3>
        <p class="event-promotion__hint">{{ langJson(live ? 'Share this link — your ticket page is live.' : 'This is your event’s ticket page. It won’t go live until you launch, but you can share it ahead of time.') }}</p>
        <div class="event-promotion__url">
            <span class="event-promotion__lock">🔗</span>
            <span class="event-promotion__link">{{ url }}</span>
        </div>
        <div class="event-promotion__actions">
            <BTN type="detail" bh="44" @handle="copyLink">{{ langJson(copied ? 'Copied' : 'Copy link') }}</BTN>
            <BTN v-if="live" type="detail" bh="44" @handle="open">{{ langJson('Open page') }}</BTN>
            <BTN v-else type="detail" bh="44" @handle="preview">{{ langJson('Preview') }}</BTN>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        event: { type: Object, required: true },
    },
    data() {
        return { copied: false }
    },
    computed: {
        live() {
            return this.event.status === 'live'
        },
        url() {
            return `${window.location.origin}/events/${this.event.id}`
        },
    },
    methods: {
        async copyLink() {
            try {
                await navigator.clipboard.writeText(this.url)
            } catch (e) {
                this.copy(this.url) // tools.js fallback for non-secure contexts
            }
            this.copied = true
            setTimeout(() => (this.copied = false), 2000)
        },
        open() {
            window.open(this.url, '_blank', 'noopener')
        },
        preview() {
            this.$router.push({ path: '/brand/events/preview', query: { id: this.event.id } })
        },
    },
}
</script>
<style lang="scss" scoped>
.event-promotion {
    background: var(--color_white);
    border-radius: 32px;
    padding: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &__title {
        font-family: 'Inter';
        font-weight: 700;
        font-size: 18px;
        color: var(--font_deep_color);
    }
    &__hint {
        font-family: 'Lato';
        font-size: 14px;
        color: var(--font_color);
    }
    &__url {
        display: flex;
        align-items: center;
        gap: 12px;
        background: var(--bg_color);
        border-radius: 50px;
        padding: 14px 20px;
        min-width: 0;
    }
    &__link {
        font-family: 'Lato';
        font-size: 14px;
        color: var(--font_deep_color);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    &__actions {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
    }
}

@media only screen and (max-width: 1080px) {
    .event-promotion {
        padding: 20px 16px;
        border-radius: 24px;
    }
}
</style>
